import { passwordSchema } from 'shared/components/vxl/input/schemas/password.schema';
import {
  getLocalPhoneDigits,
  hasInvalidPhoneAreaCode,
  PHONE_DIGIT_COUNT,
} from 'shared/utils/string/phone';
import { z } from 'zod';

const MAX_EMAIL_LENGTH = 128;
const emailValidationMessages = {
  invalid: 'Please enter a valid email address',
  required: 'Required',
};
const phoneValidationMessages = {
  invalidAreaCode: 'Enter a valid area code',
  invalidLength: 'Number must be 10 digits',
  required: 'Required',
};

const createAccountEmailSchema = z
  .email({ error: emailValidationMessages.invalid })
  .min(1, { error: emailValidationMessages.required })
  .max(MAX_EMAIL_LENGTH, { error: emailValidationMessages.invalid });

const createAccountPhoneSchema = z
  .string({ error: phoneValidationMessages.required })
  .min(1, { error: phoneValidationMessages.required })
  .refine((value) => !hasInvalidPhoneAreaCode(value), {
    error: phoneValidationMessages.invalidAreaCode,
  })
  .refine((value) => getLocalPhoneDigits(value).length === PHONE_DIGIT_COUNT, {
    error: phoneValidationMessages.invalidLength,
  });

export const createAccountVerificationSchema = z.object({
  email: createAccountEmailSchema,
  phone: createAccountPhoneSchema,
  password: passwordSchema,
});
